import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import {Header} from '../../Components/Header';
import {updateAmount, getLocalTillagg, updateTillaggForm} from '../../Services/Tillagg/action';
import Checkboxes from '../../Components/Checkboxes';


import './style.scss';

class Step2 extends Component {
    constructor(props, context) {
		super(props, context);

        this.state = {
            activeRow: false
        }
    }

    updateValue = (e, index) => {
        let name = e.target.name;
        let value = e.target.value;
        let obj = {
            [name] : value
        }
        this.props.updateAmount(obj, index);
        this.validate();
    }
    validate = () => {

    }
    checkLocalStorage = () => {
        let localTillagg = localStorage.getItem('tillagg-welandutemiljo');
        if(localTillagg !== null)
        {
            this.props.getLocalTillagg(JSON.parse(localTillagg));
        }
    }

    updateCheckBox = (e, index, type, value) => {
        let truefalse;
        if(value)
        {
            truefalse = false;
        }else {
            truefalse = true;
        }
        this.props.updateTillaggForm(index, type, truefalse);
    } 

    componentWillMount = () => {
        this.checkLocalStorage();
    }

    render = () => {
        const {tillagg, form} = this.props;
        let textarea;
        let stativChecked = false;
        let stativavslutChecked = false;
        let banderollChecked = false;
        let glasChecked = false;

        let showNextButton = false;

        if(form.stativ)
        {
            form.stativ.map((value, key) => {
                if(value.checked)
                {
                    stativChecked = true;
                }
            });
        }
        if(form.stativavslut)
        {
            form.stativavslut.map((value, key) => {
                if(value.checked)
                {
                    stativavslutChecked = true
                }
            })
        }
        if(form.banderoll)
        {
            form.banderoll.map((value, index) => {
                if(value.checked)
                {
                    banderollChecked = true;
                }
            })
        }
        if(form.glas)
        {
            form.glas.map((value, index) => {
                if(value.checked)
                {
                    glasChecked = true
                }
            })
        }
        if(stativChecked && stativavslutChecked)
        {
            if(banderollChecked || glasChecked)
            {
                showNextButton = true;
            }
            
        }


        if(form.banderoll)
        {
            if(form.banderoll[0].checked){
                textarea = (
                    <div className="field is-horizontal">
                        <div className="field-label">
                            <label className="label"> Lägg till artikelnummer
                            </label>
                        </div>
                        <div className="field-body">
                            <div className="field">
                                <div className="control">
                                    <div className="textarea" contentEditable></div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
        return (
            <div className="step2">
                <div className="container is-fluid">
                    <Header title="Lägg till tillval för ditt staket" subtitle="Steg 2 / 4 för skapande av staket" activeNextButton={showNextButton} nextPageLink="/3"  />
                    <div className="hero transparent">
                        <div className="hero-body" style={{paddingBottom: '0px'}}>
                            <div className="container items-container">
                                <p>För att komma vidare till nästa steg. Var vänlig fyll i stativfärg, stativavslut och om ni vill ha banderoll eller glas.</p>
                            </div>
                        </div>
                    </div>

                </div>
                <Checkboxes />
                <div className="container">
                    <h2 className="is-size-3">Tillval</h2>
                </div>
                <div className="items-wrap">
                {
                    tillagg.map((value, index) => {
                        return (
                            <div className="hero items" key={index}>
                                <div className="hero-body">
                                    <div className="container items-container">
                                        <div className="columns">
                                            <div className="column is-2 has-text-centered">
                                                <p className="image is-96x96">
                                                    <img src={value.image} />
                                                </p>
                                            </div>
                                            <div className="column is-2">
                                                <h2>Produktnamn</h2>
                                                <p>{value.product_name}</p>
                                            </div>
                                            <div className="column is-4">
                                                <h2>Produktbeskrivning</h2>
                                                <p>{value.description}</p>
                                            </div>
                                            <div className="column is-2">
                                                <h2>Pris</h2>
                                                <p>{value.price}</p>
                                            </div>
                                            <div className="column is-2">
                                                <div className="">
                                                <h2>Lägg till antal</h2>
                                                <input type="number" min="0" value={value.amount} name="amount" onChange={(e) => this.updateValue(e, index)} className="input-number" /> st
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        )
                    })
                }
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        tillagg: state.tillagg.tillagg,
        form: state.tillagg.tillaggform
    };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateAmount: bindActionCreators(updateAmount, dispatch),
    getLocalTillagg: bindActionCreators(getLocalTillagg, dispatch),
    updateTillaggForm: bindActionCreators(updateTillaggForm, dispatch)
  };
}; 


export default connect(mapStateToProps, mapDispatchToProps)(Step2);


// WEBPACK FOOTER //
// ./src/Scenes/Step2/index.js